/**
 * Parses a stored high-school graduation year. Only a plain four-digit decimal
 * string counts; Number() alone would also accept hex, exponent, signed, and
 * decimal notations whose raw stored form is not a deliverable year.
 *
 * Shared by the lead-eligibility gate, hosted GRAD_YEAR validation, and option
 * filtering so all three use the same definition of a valid year.
 */
export function parseGradYear(value: string | null | undefined): number | null {
  if (!value || value.length !== 4 || !/^\d{4}$/.test(value)) return null;
  return Number(value);
}
